export const iconFontAwesomeMoneyScaleUnbalanced = (
	<i className="fa-solid fa-scale-unbalanced"></i>
);
